import { Button } from "@/components/ui/button";

export function BatchBar({ count, actions, onClear }) {
  if (!count) return null;
  return (
    <div data-testid="batch-action-bar" className="flex items-center gap-2 flex-wrap px-3 py-2 rounded-lg border border-slate-200 bg-slate-50">
      <span className="text-sm font-medium text-slate-600">{count} selected</span>
      {actions.map((a) => (
        <Button key={a.key} size="sm" variant="outline" className={a.className} data-testid={`batch-${a.key}-btn`} onClick={a.onClick} disabled={a.disabled}>
          {a.icon}{a.label}
        </Button>
      ))}
      <Button size="sm" variant="ghost" data-testid="batch-clear-btn" onClick={onClear}>Clear</Button>
    </div>
  );
}
